import { Action, createReducer, on } from '@ngrx/store';

import { FlightClass } from '@shared/base-search-bar/entities/flight-class';
import { selectFlightClassAction } from '../actions/search-bar.actions';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';

export const initialState = FlightClass.CHEAPER;

const reducer = createReducer(
  initialState,
  on(selectFlightClassAction, (state, { flightClass }) => {
    return flightClass;
  }),
  on(loadSearchDataSuccessAction, (state, { data }) => data ? data.flightClass : initialState)
);

export function flightClassReducer(state: FlightClass, action: Action): FlightClass {
  return reducer(state, action);
}
